export type ThemeName = 'messenger' | 'debug';

export interface ThemeOptions {
  defaultTheme?: ThemeName;
}

const THEME_CLASSES: ThemeName[] = ['messenger', 'debug'];

export function applyThemeFromQuery(options: ThemeOptions = {}) {
  const { defaultTheme = 'messenger' } = options;
  const themeParam = new URLSearchParams(window.location.search).get('theme');
  const resolvedTheme = themeParam === 'debug' ? 'debug' : defaultTheme;
  const themeClass = `theme-${resolvedTheme}`;

  THEME_CLASSES.forEach((theme) => {
    document.documentElement.classList.remove(`theme-${theme}`);
    document.body.classList.remove(`theme-${theme}`);
  });

  document.documentElement.classList.add(themeClass);
  document.body.classList.add(themeClass);
  document.documentElement.setAttribute('data-theme', resolvedTheme);

  return resolvedTheme;
}
